module.exports = __webpack_public_path__ + "static/media/banner-porter-invite.37332a32.png";